import { createTheme } from "@mui/material/styles";
import { grey } from "@mui/material/colors";

export const theme = createTheme({
  palette: {
    divider: grey[400],
  },
  components: {
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: ({ theme }) => ({
          border: `1px solid ${theme.palette.divider}`,
        }),
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: "0.75rem",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "0.75rem",
        },
      },
    },
    // A select box is auto-height, so it takes the line height inherited from
    // the input root (sized for the default 1rem) rather than the smaller input
    // font size above. Re-anchor it so selects match text fields beside them.
    MuiSelect: {
      styleOverrides: {
        select: {
          lineHeight: "1.4375em",
        },
      },
    },
  },
});
